import {
  BodyText,
  BodyTextProps,
  SvgComponent,
} from '@grays-npm/component-library';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

export type ListingIconFieldProps = {
  icon?: SvgComponent;
  contentComponent?: React.ComponentType<BodyTextProps>;
  title?: string;
};

const IconFieldContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;

  > * + * {
    margin-left: ${({ theme }) => theme.spacings[1].rem};
  }
`;

const TextContent = styled(BodyText).attrs({ size: { xs: 'xs', sm: 'sm' } })``;

export const ListingIconField: React.FC<
  PropsWithChildren<ListingIconFieldProps>
> = ({
  icon: Icon,
  children,
  contentComponent: Content = TextContent,
  ...props
}) => {
  return (
    <IconFieldContainer {...props}>
      {Icon && <Icon />} <Content>{children}</Content>
    </IconFieldContainer>
  );
};
